// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1enfX","header":"PatientBlock_header__X8RIp","label":"PatientBlock_label__BLqO5","option":"PatientBlock_option__2npWA"};